import React from 'react';
import { Select } from '../../styleguide';
import _ from 'lodash';
import { CAMPAIGNS_MAP as CAMPAIGNS } from '../../constants';
import { hasFeature } from '../utils';
const { Option } = Select;

function CampaignTypeDropdown({ hideLegacyPlaceholder, currentUser, propertyType, updateCampaignType }) {
  const getCampaignDropDownOptions = () => {
    let campaignsTypes = _.omit(CAMPAIGNS, 0);

    const hasTcfv2 = hasFeature(currentUser, 'tcf_v2');
    const hasCcpa = hasFeature(currentUser, 'ccpa');
    const hasUsnat = hasFeature(currentUser, 'usnat');
    const hasGlobalEnterprise = hasFeature(currentUser, 'global_enterprise');
    const hasPreferences = hasFeature(currentUser, 'marketing_preferences') || hasFeature(currentUser, 'legal_preferences');
    const hasAdblock = hasFeature(currentUser, 'adblock_v2');
    const hasAppleMessaging = hasFeature(currentUser, 'apple_messaging');
    const hasCustomMessaging = hasFeature(currentUser, 'custom_messages');

    if (!hasTcfv2) {
      delete campaignsTypes[1];
    }
    if (!hasCcpa) {
      delete campaignsTypes[2];
    }
    if (!hasUsnat) {
      delete campaignsTypes[6];
    }
    if (!hasGlobalEnterprise) {
      delete campaignsTypes[8];
    }
    if (!hasPreferences) {
      delete campaignsTypes[7];
    }
    if (!hasAdblock || propertyType === 'ott' || propertyType === 'app') {
      delete campaignsTypes[3];
    }
    if (!hasAppleMessaging || propertyType === 'ott' || propertyType === 'web') {
      delete campaignsTypes[4];
    }
    if (!hasCustomMessaging) {
      delete campaignsTypes[5];
    }

    return campaignsTypes;
  };

  const campaignsTypes = getCampaignDropDownOptions();
  const options = Object.entries(campaignsTypes).map(([key, value]) => ({label: value, value: Number(key)})).sort((a,b) => a.label.localeCompare(b.label));

  return (
    <Select 
      placeholder="Select"
      className="campaign-types-select-dropdown"
      defaultValue={hideLegacyPlaceholder ? '' : 'No Type'} 
      onChange={(value) => updateCampaignType(value)}
      options={options}
      />
  );
}

export default CampaignTypeDropdown;
